import React from "react";
import IntegrationLayout from "./integrationLayout.jsx";
import CRMTab from "./crmtab.jsx";
import LMSTab from "./lmstab.jsx";
import PAYMENTTab from "./paymenttab.jsx";
import DOCUMENTTab from "./documenttab.jsx";
import COLLECTIONSTab from "./collectionstab.jsx";

const IntegrationCenterPage = () => {
  const tabs = [
    { label: "CRM", value: "CRM", component: <CRMTab /> },
    { label: "LMS", value: "LMS", component: <LMSTab /> },
    { label: "PAYMENT", value: "PAYMENT", component: <PAYMENTTab /> },
    { label: "DOCUMENT", value: "DOCUMENT", component: <DOCUMENTTab /> },
    { label: "COLLECTIONS", value: "COLLECTIONS", component: <COLLECTIONSTab /> },
    //{ label: "IVR", value: "IVR", component: <div>Payment</div> }
    //{ label: "History", value: "History", component: <CustomerHistory /> },
  ];

  return (
    <IntegrationLayout
      //leftPanel={<Calls />}
      tabConfig={tabs}
      defaultTab="CRM"
      title="Customer Information"
    />
  );
};

export default IntegrationCenterPage;
